import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";
import { Observable, of } from "rxjs";
import { AbstractFormComponent } from "src/app/admin/common/abstract-edit.component";
import {
  FEATURED_OPTIONS,
  PARAM_CATEGORIES_PATH,
  STATE_LIST,
} from "src/app/admin/constants/constants";
import { Category } from "src/app/models/category";
import { CategoryService } from "src/app/services/categories.service";
import { CommonModule } from "@angular/common";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { SelectModule } from "primeng/select";
import { TooltipModule } from "primeng/tooltip";

import { SelectButtonModule } from "primeng/selectbutton";

@Component({
  standalone: true,
  selector: "app-categories-form",
  templateUrl: "./categories-form.component.html",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    ToastModule,
    ConfirmDialogModule,
    SelectModule,
    TooltipModule, SelectButtonModule,],
})
export class CategoriesFormComponent
  extends AbstractFormComponent<Category>
  implements OnInit
{
  pageTitle: string;
  form: FormGroup;
  idField = "id";
  formFields = [
    "id",
    "category_name",
    "category_description",
    "page_url",
    "featured",
    "seo_description",
    "is_active",
  ];
  selectedStatePublished: SelectItem[] = [];

  stateOptions = STATE_LIST;
  statePublished = FEATURED_OPTIONS;
  service = this.categoryService; // Implement the abstract service property

  constructor(
    protected fb: FormBuilder,
    private categoryService: CategoryService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(PARAM_CATEGORIES_PATH);
  }

  ngOnInit() {
    this.initializeForm();
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle = "Modifica Category";
      this.loadItem(+id);
    } else {
      this.pageTitle = "Aggiungi Category";
    }
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [""],
      category_name: ["", Validators.required],
      category_description: [""],
      page_url: [""],
      seo_title: [""],
      seo_description: [""],
      is_active: ["0"],
      featured: ["0"],
    });
  }

  loadItem(id: number) {
    this.service.getId(id).subscribe(
      (res) => {
        this.form.patchValue({
          category_name: res.category_name,
          category_description: res.category_description,
          page_url: res.page_url,
          seo_title: res.seo_title,
          featured: res.featured,
          seo_description: res.seo_description,
          is_active: res.is_active,
          id: res.id,
        });
      },
      (error) => (this.error = error),
    );
  }
}
